var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Asignar Velocidad ")])],
        1
      ),
      _c("v-divider"),
      _c("ComandoVelocidad")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }